import { type TransportAirlineApiContext } from "../../../../common/utils/transport/airlineTransportContext";

export type FrankfurtCardResolvedPaths =
  | { kind: "invalid_airline" }
  | { kind: "unsupported_platform" }
  | {
      kind: "ok";
      mainPath: string;
      bookingsPath: string;
    };

// Frankfurt Card is a Transfer Hub-only offer: the backend serves it for airline airports only.
export function resolveFrankfurtCardApiPaths(transportContext: TransportAirlineApiContext): FrankfurtCardResolvedPaths {
  if (transportContext.mode === "airline_missing_iata") {
    return { kind: "invalid_airline" };
  }

  if (transportContext.mode === "airline") {
    const iataCode = encodeURIComponent(transportContext.iataCode);

    return {
      kind: "ok",
      mainPath: `v1/airports/${iataCode}/transports/frankfurt-card`,
      bookingsPath: `v1/airports/${iataCode}/bookings`
    };
  }

  return { kind: "unsupported_platform" };
}
